export const entityAgents = [
  {
  "name": "Campanha",
  "nameEn": "Campaign",
  "areas": [
    "marketing"
  ],
  "context": "Público, objetivo, canais, orçamento e resultados da campanha",
  "contextEn": "Audience, objective, channels, budget and campaign results",
  "agents": [
    [
      "Planejador de campanhas",
      "Campaign planner",
      "Organiza o briefing, sugere públicos e canais e prepara tarefas para aprovação da equipe.",
      "Organizes the brief, suggests audiences and channels, and prepares tasks for team approval."
    ],
    [
      "Analista de campanhas",
      "Campaign analyst",
      "Consolida resultados, identifica sinais de interesse e encaminha leads ao CRM com o contexto da campanha.",
      "Consolidates results, identifies interest signals, and routes leads to the CRM with campaign context."
    ]
  ]
},
  {
    "name": "Lead",
    "nameEn": "Lead",
    "areas": [
      "marketing",
      "commercial"
    ],
    "context": "Origem, interesse e histórico de contato",
    "contextEn": "Source, interest and contact history",
    "agents": [
      [
        "Qualificador de leads",
        "Lead qualifier",
        "Consulta o CRM, identifica dados faltantes e prepara a qualificação.",
        "Checks CRM records, identifies missing data and prepares qualification."
      ],
      [
        "Roteador comercial",
        "Sales router",
        "Sugere o responsável e cria a tarefa de abordagem com contexto.",
        "Suggests an owner and creates a contextual outreach task."
      ]
    ]
  },
  {
    "name": "Oportunidade",
    "nameEn": "Opportunity",
    "areas": [
      "commercial",
      "sales"
    ],
    "context": "CRM, necessidades e interações",
    "contextEn": "CRM, needs and interactions",
    "agents": [
      [
        "Analista de oportunidades",
        "Opportunity analyst",
        "Reúne requisitos e pendências para a próxima reunião.",
        "Collects requirements and open items for the next meeting."
      ],
      [
        "Coordenador de follow-up",
        "Follow-up coordinator",
        "Prepara retornos e acompanha tarefas da negociação.",
        "Prepares follow-ups and tracks negotiation tasks."
      ]
    ]
  },
  {
    "name": "Pré-venda",
    "nameEn": "Presales",
    "areas": [
      "commercial",
      "production"
    ],
    "context": "Requisitos, catálogo e documentação técnica",
    "contextEn": "Requirements, catalog and technical documentation",
    "agents": [
      [
        "Consultor técnico",
        "Technical advisor",
        "Busca especificações aprovadas e prepara respostas aos requisitos.",
        "Retrieves approved specifications and prepares requirement responses."
      ],
      [
        "Analista de viabilidade",
        "Feasibility analyst",
        "Consolida restrições e encaminha a solução para validação técnica.",
        "Consolidates constraints and routes the solution for technical validation."
      ]
    ]
  },
  {
    "name": "Orçamento de Venda",
    "nameEn": "Sales Quote",
    "areas": [
      "commercial",
      "inventory",
      "finance"
    ],
    "context": "Produtos, disponibilidade e condições comerciais",
    "contextEn": "Products, availability and commercial terms",
    "agents": [
      [
        "Preparador de propostas",
        "Proposal preparer",
        "Consulta preços e estoque e monta uma proposta para revisão.",
        "Checks prices and stock and assembles a proposal for review."
      ],
      [
        "Revisor de condições",
        "Terms reviewer",
        "Destaca descontos e condições fora da política para aprovação.",
        "Flags discounts and terms outside policy for approval."
      ]
    ]
  },
  {
    "name": "Ordem de Venda",
    "nameEn": "Sales Order",
    "areas": [
      "sales",
      "production",
      "inventory",
      "finance"
    ],
    "context": "Pedido aprovado, itens, prazos e cliente",
    "contextEn": "Approved order, items, deadlines and customer",
    "agents": [
      [
        "Orquestrador de pedidos",
        "Order orchestrator",
        "Abre tarefas para produção, separação e faturamento conforme a ordem aprovada.",
        "Creates production, picking and billing tasks from the approved order."
      ],
      [
        "Monitor de pendências",
        "Exception monitor",
        "Acompanha dependências e aciona responsáveis por bloqueios.",
        "Tracks dependencies and notifies owners of blockers."
      ]
    ]
  },
  {
    "name": "Ordem de Produção",
    "nameEn": "Production Order",
    "areas": [
      "production",
      "purchasing",
      "inventory"
    ],
    "context": "Materiais, capacidade e programação do ERP",
    "contextEn": "Materials, capacity and ERP schedule",
    "agents": [
      [
        "Planejador de materiais",
        "Materials planner",
        "Identifica faltas e prepara solicitações de compra para o planejador.",
        "Identifies shortages and prepares purchasing requests for the planner."
      ],
      [
        "Monitor de produção",
        "Production monitor",
        "Reúne apontamentos e sinaliza desvios de prazo e qualidade.",
        "Collects production records and flags schedule and quality deviations."
      ]
    ]
  },
  {
    "name": "Produto acabado",
    "nameEn": "Finished goods",
    "areas": [
      "production",
      "inventory"
    ],
    "context": "Apontamentos, lotes e liberação da qualidade",
    "contextEn": "Production records, batches and quality release",
    "agents": [
      [
        "Conferente de produção",
        "Production checker",
        "Compara quantidades produzidas com a ordem e registra divergências.",
        "Compares completed quantities with the order and records discrepancies."
      ],
      [
        "Coordenador de disponibilidade",
        "Availability coordinator",
        "Após liberação, comunica disponibilidade para estoque e vendas.",
        "After release, communicates availability to inventory and sales."
      ]
    ]
  },
  {
    "name": "Estoque",
    "nameEn": "Inventory",
    "areas": [
      "inventory",
      "purchasing",
      "sales"
    ],
    "context": "Saldos, reservas e movimentações",
    "contextEn": "Balances, reservations and movements",
    "agents": [
      [
        "Monitor de reposição",
        "Replenishment monitor",
        "Identifica risco de falta e prepara tarefas de reposição.",
        "Identifies shortage risks and prepares replenishment tasks."
      ],
      [
        "Analista de divergências",
        "Discrepancy analyst",
        "Cruza registros de entrada e saída e encaminha diferenças para conferência.",
        "Cross-checks inbound and outbound records and routes differences for checking."
      ]
    ]
  },
  {
    "name": "Ordem de Serviço",
    "nameEn": "Service Order",
    "areas": [
      "sales",
      "production",
      "logistics"
    ],
    "context": "Escopo, equipe, agenda e evidências",
    "contextEn": "Scope, team, schedule and evidence",
    "agents": [
      [
        "Coordenador de serviços",
        "Service coordinator",
        "Organiza tarefas e documentos necessários à execução.",
        "Organizes tasks and documents needed for execution."
      ],
      [
        "Conferente de execução",
        "Service completion checker",
        "Reúne evidências e solicita validação antes do encerramento.",
        "Collects evidence and requests validation before closure."
      ]
    ]
  },
  {
    "name": "Remessa",
    "nameEn": "Shipment",
    "areas": [
      "inventory",
      "logistics"
    ],
    "context": "Itens, destino e data prevista",
    "contextEn": "Items, destination and expected date",
    "agents": [
      [
        "Preparador de remessas",
        "Shipment preparer",
        "Confere itens e destino e prepara o pacote para expedição.",
        "Checks items and destination and prepares the dispatch package."
      ],
      [
        "Monitor de entrega",
        "Delivery monitor",
        "Consulta eventos e direciona ocorrências ao responsável.",
        "Checks events and routes incidents to the owner."
      ]
    ]
  },
  {
    "name": "Picking",
    "nameEn": "Picking",
    "areas": [
      "inventory",
      "logistics"
    ],
    "context": "Reservas, endereços e lista de separação",
    "contextEn": "Reservations, locations and pick list",
    "agents": [
      [
        "Assistente de separação",
        "Picking assistant",
        "Reúne instruções de separação a partir do WMS.",
        "Collects picking instructions from the WMS."
      ],
      [
        "Tratador de faltas",
        "Shortage handler",
        "Abre tarefas para itens indisponíveis e comunica impacto na entrega.",
        "Creates tasks for unavailable items and communicates delivery impact."
      ]
    ]
  },
  {
    "name": "Packing",
    "nameEn": "Packing",
    "areas": [
      "inventory",
      "logistics"
    ],
    "context": "Itens separados, volumes e embalagem",
    "contextEn": "Picked items, packages and packaging",
    "agents": [
      [
        "Conferente de volumes",
        "Package checker",
        "Compara itens separados com pedido e volumes registrados.",
        "Compares picked items with the order and recorded packages."
      ],
      [
        "Preparador de etiquetas",
        "Label preparer",
        "Prepara dados de etiquetas e encaminha inconsistências para revisão.",
        "Prepares label data and routes inconsistencies for review."
      ]
    ]
  },
  {
    "name": "Romaneio",
    "nameEn": "Dispatch List",
    "areas": [
      "logistics",
      "inventory"
    ],
    "context": "Remessas, volumes e transportadora",
    "contextEn": "Shipments, packages and carrier",
    "agents": [
      [
        "Consolidador de expedição",
        "Dispatch consolidator",
        "Agrupa remessas e prepara o romaneio para conferência.",
        "Groups shipments and prepares the dispatch list for checking."
      ],
      [
        "Conferente de carga",
        "Load checker",
        "Identifica volumes ou documentos faltantes antes da saída.",
        "Identifies missing packages or documents before departure."
      ]
    ]
  },
  {
    "name": "CT-e",
    "nameEn": "CT-e",
    "areas": [
      "logistics",
      "tax"
    ],
    "context": "Dados de transporte, partes e documentos vinculados",
    "contextEn": "Transport data, parties and linked documents",
    "agents": [
      [
        "Conferente de transporte",
        "Transport document checker",
        "Compara dados da operação e destaca inconsistências documentais.",
        "Compares operation data and flags document inconsistencies."
      ],
      [
        "Monitor documental",
        "Document monitor",
        "Acompanha status no sistema integrado e encaminha rejeições ao Fiscal.",
        "Tracks status in the integrated system and routes rejections to Tax."
      ]
    ]
  },
  {
    "name": "MDF-e",
    "nameEn": "MDF-e",
    "areas": [
      "logistics",
      "tax"
    ],
    "context": "Viagem, veículo, condutor e documentos vinculados",
    "contextEn": "Trip, vehicle, driver and linked documents",
    "agents": [
      [
        "Preparador de manifesto",
        "Manifest preparer",
        "Consolida dados da viagem para revisão no sistema fiscal.",
        "Consolidates trip data for review in the tax system."
      ],
      [
        "Monitor de viagem documental",
        "Trip document monitor",
        "Acompanha pendências de documentos e encerramento com o responsável.",
        "Tracks document and closure exceptions with the owner."
      ]
    ]
  },
  {
    "name": "Fatura de Venda",
    "nameEn": "Sales Invoice",
    "areas": [
      "sales",
      "tax",
      "finance"
    ],
    "context": "Ordem aprovada, execução e condições de pagamento",
    "contextEn": "Approved order, fulfillment and payment terms",
    "agents": [
      [
        "Preparador de faturamento",
        "Billing preparer",
        "Reúne itens e evidências para o faturamento.",
        "Collects items and evidence for billing."
      ],
      [
        "Validador de cobrança",
        "Billing validator",
        "Compara valores e condições com o pedido e aponta diferenças.",
        "Compares amounts and terms with the order and flags differences."
      ]
    ]
  },
  {
    "name": "NFS-e ou NF-e",
    "nameEn": "NFS-e or NF-e",
    "areas": [
      "tax",
      "finance",
      "accounting"
    ],
    "context": "Cadastro, itens e dados da operação",
    "contextEn": "Master records, items and operation data",
    "agents": [
      [
        "Revisor fiscal",
        "Tax reviewer",
        "Confere completude dos dados e encaminha dúvidas ao especialista.",
        "Checks data completeness and routes questions to the specialist."
      ],
      [
        "Monitor de emissão",
        "Issuance monitor",
        "Acompanha a emissão autorizada no sistema integrado e organiza retornos.",
        "Tracks authorized issuance in the integrated system and organizes responses."
      ]
    ]
  },
  {
    "name": "Contas a Receber",
    "nameEn": "Accounts Receivable",
    "areas": [
      "finance",
      "sales"
    ],
    "context": "Títulos, vencimentos e histórico do cliente",
    "contextEn": "Receivables, due dates and customer history",
    "agents": [
      [
        "Agente de cobrança",
        "Collections agent",
        "Prepara lembretes conforme a política e encaminha negociações.",
        "Prepares policy-based reminders and routes negotiations."
      ],
      [
        "Conciliador de recebimentos",
        "Receipts reconciler",
        "Sugere correspondências entre títulos e recebimentos para revisão.",
        "Suggests matches between receivables and receipts for review."
      ]
    ]
  },
  {
    "name": "Solicitação de Cotação",
    "nameEn": "Request for Quotation",
    "areas": [
      "purchasing",
      "production"
    ],
    "context": "Necessidade, especificações e prazo",
    "contextEn": "Needs, specifications and deadline",
    "agents": [
      [
        "Consolidador de demandas",
        "Demand consolidator",
        "Agrupa necessidades e confere especificações para cotação.",
        "Groups needs and checks quotation specifications."
      ],
      [
        "Preparador de consulta",
        "RFQ preparer",
        "Monta a solicitação para fornecedores homologados e aprovação de envio.",
        "Prepares requests for approved suppliers and submission approval."
      ]
    ]
  },
  {
    "name": "Cotação",
    "nameEn": "Quotation",
    "areas": [
      "purchasing",
      "finance"
    ],
    "context": "Propostas, preços, prazos e condições",
    "contextEn": "Proposals, prices, deadlines and terms",
    "agents": [
      [
        "Comparador de propostas",
        "Proposal comparator",
        "Normaliza propostas e compara condições com as fontes.",
        "Normalizes proposals and compares terms with source records."
      ],
      [
        "Analista de pendências",
        "Quotation exception analyst",
        "Identifica dados ausentes e prepara perguntas aos fornecedores.",
        "Identifies missing data and prepares supplier questions."
      ]
    ]
  },
  {
    "name": "Ordem de Compra",
    "nameEn": "Purchase Order",
    "areas": [
      "purchasing",
      "inventory",
      "finance"
    ],
    "context": "Cotação aprovada, fornecedor e entrega",
    "contextEn": "Approved quotation, supplier and delivery",
    "agents": [
      [
        "Preparador de pedidos de compra",
        "Purchase order preparer",
        "Prepara o pedido conforme a cotação aprovada.",
        "Prepares the order based on the approved quotation."
      ],
      [
        "Monitor de fornecedores",
        "Supplier monitor",
        "Acompanha previsão de entrega e alerta as áreas sobre atrasos.",
        "Tracks delivery forecasts and alerts departments to delays."
      ]
    ]
  },
  {
    "name": "Fatura de Compra",
    "nameEn": "Purchase Invoice",
    "areas": [
      "purchasing",
      "tax",
      "finance"
    ],
    "context": "Pedido, recebimento e documento do fornecedor",
    "contextEn": "Order, receipt and supplier document",
    "agents": [
      [
        "Conferente de três vias",
        "Three-way matching agent",
        "Compara pedido, recebimento e fatura e destaca divergências.",
        "Compares order, receipt and invoice and flags discrepancies."
      ],
      [
        "Classificador de despesas",
        "Expense classifier",
        "Sugere categoria e centro de custo para aprovação.",
        "Suggests expense category and cost center for approval."
      ]
    ]
  },
  {
    "name": "Contas a Pagar",
    "nameEn": "Accounts Payable",
    "areas": [
      "finance",
      "purchasing"
    ],
    "context": "Títulos, aprovações e vencimentos",
    "contextEn": "Payables, approvals and due dates",
    "agents": [
      [
        "Organizador de pagamentos",
        "Payment organizer",
        "Prepara a agenda de vencimentos e solicita aprovações pendentes.",
        "Prepares the due-date schedule and requests pending approvals."
      ],
      [
        "Detector de duplicidades",
        "Duplicate checker",
        "Sinaliza possíveis títulos duplicados para conferência humana.",
        "Flags potentially duplicate invoices for human checking."
      ]
    ]
  },
  {
    "name": "Fluxo de Caixa",
    "nameEn": "Cash Flow",
    "areas": [
      "finance",
      "accounting"
    ],
    "context": "Previsões, títulos e saldos conciliados",
    "contextEn": "Forecasts, invoices and reconciled balances",
    "agents": [
      [
        "Projetor de caixa",
        "Cash forecaster",
        "Consolida entradas e saídas previstas com hipóteses explícitas.",
        "Consolidates expected inflows and outflows with explicit assumptions."
      ],
      [
        "Analista de desvios",
        "Variance analyst",
        "Compara previsto e realizado e prepara explicações para revisão.",
        "Compares forecasts with actuals and prepares explanations for review."
      ]
    ]
  },
  {
    "name": "Fechamento contábil",
    "nameEn": "Accounting Close",
    "areas": [
      "accounting",
      "tax",
      "finance"
    ],
    "context": "Movimentos e documentos de suporte",
    "contextEn": "Movements and supporting documents",
    "agents": [
      [
        "Conciliador contábil",
        "Accounting reconciler",
        "Identifica diferenças entre fiscal, financeiro e estoque.",
        "Identifies differences across tax, finance and inventory."
      ],
      [
        "Organizador de evidências",
        "Evidence organizer",
        "Solicita documentos faltantes e acompanha o checklist de fechamento.",
        "Requests missing documents and tracks the close checklist."
      ]
    ]
  },
  {
    "name": "Integrações e acessos",
    "nameEn": "Integrations and Access",
    "areas": [
      "it"
    ],
    "context": "Conectores, permissões e chamados",
    "contextEn": "Connectors, permissions and tickets",
    "agents": [
      [
        "Monitor de integrações",
        "Integration monitor",
        "Reúne falhas dos conectores e abre incidentes com contexto.",
        "Collects connector failures and opens contextual incidents."
      ],
      [
        "Assistente de suporte",
        "Support assistant",
        "Consulta a base técnica e propõe ações para aprovação da TI.",
        "Checks technical knowledge and proposes actions for IT approval."
      ]
    ]
  },
  {
    "name": "Pessoas e capacitação",
    "nameEn": "People and Training",
    "areas": [
      "hr",
      "it"
    ],
    "context": "Políticas, funções e trilhas de aprendizado",
    "contextEn": "Policies, roles and learning paths",
    "agents": [
      [
        "Coordenador de onboarding",
        "Onboarding coordinator",
        "Acompanha tarefas de admissão aprovada entre RH, gestor e TI.",
        "Tracks approved onboarding tasks across HR, managers and IT."
      ],
      [
        "Tutor corporativo",
        "Corporate tutor",
        "Consulta políticas aprovadas e sugere conteúdos de capacitação.",
        "Consults approved policies and suggests training content."
      ]
    ]
  }
];
